import axios from "@/plugins/axios";

let url = "/api/v1/shop/displays";

export default {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    }
}
